import { getFitmentResult, readStoredVehicle } from '@theme/fitment-matcher';

const LINE_WARNING_NO_FIT = 'Does not fit your selected vehicle';
const LINE_WARNING_MOD = 'May require hub rings, trimming, or other modifications';

function updateCartFitment() {
  const vehicle = readStoredVehicle();
  let hasNoFit = false;
  let hasModification = false;

  document.querySelectorAll('[data-fitment-variant]').forEach((row) => {
    const warning = row.querySelector('[data-fitment-line-warning]');
    const variantText = row.getAttribute('data-fitment-variant')?.trim() ?? '';
    const result = variantText ? getFitmentResult(variantText, vehicle) : vehicle ? 'unknown' : 'no_vehicle';

    if (!(warning instanceof HTMLElement)) return;

    if (result === 'no_fit') {
      warning.textContent = LINE_WARNING_NO_FIT;
      warning.classList.remove('hidden', 'method-fitment-warning--modification');
      warning.classList.add('method-fitment-warning--no-fit');
      hasNoFit = true;
      return;
    }

    if (result === 'modification_required') {
      warning.textContent = LINE_WARNING_MOD;
      warning.classList.remove('hidden', 'method-fitment-warning--no-fit');
      warning.classList.add('method-fitment-warning--modification');
      hasModification = true;
      return;
    }

    warning.classList.add('hidden');
  });

  document.querySelectorAll('[data-fitment-cart-summary-warning]').forEach((el) => {
    if (!(el instanceof HTMLElement)) return;
    if (!vehicle) {
      el.classList.add('hidden');
      return;
    }

    el.classList.toggle('hidden', !hasNoFit && !hasModification);
    el.classList.toggle('method-fitment-warning--no-fit', hasNoFit);
    el.classList.toggle('method-fitment-warning--modification', !hasNoFit && hasModification);
    el.textContent = hasNoFit
      ? 'One or more items do not fit your selected vehicle.'
      : hasModification
        ? 'One or more items may require modifications for your vehicle.'
        : el.textContent;
  });
}

function initCartFitment() {
  if (!document.querySelector('[data-fitment-variant]') && !document.querySelector('[data-fitment-cart-summary-warning]')) {
    return;
  }

  updateCartFitment();
  document.addEventListener('vehiclefitment:change', updateCartFitment);
  document.addEventListener('cart:update', () => {
    requestAnimationFrame(updateCartFitment);
  });
}

document.addEventListener('DOMContentLoaded', initCartFitment);
